export default {
  login: "/admin/login.php",
  authorised: "/admin/authorise.php",

  fetchFlats: "/flats/get-flats.php",
  addFlat: "/flats/add-flat.php",
  updateFlat: "/flats/update-flat.php",
  deleteFlat: "/flats/delete-flat.php",
  flatsRandomAssignment: "/flats/assign-flats-random.php",
  assignFlatToUser: "/flats/assign-flat-to-user.php",
  uploadFlats: "/flats/upload-csv.php",
  removeAllotment: "/flats/cancel-allotment.php",
  searchData: "/flats/search-data.php",
  truncateFlats: "/flats/truncate.php",
  truncateFlatUserMapping: "/flats/truncate-mapping.php",
  manualFlatAssignment: "/flats/manual-flat-assignment.php",

  fetchUsers: "/users/get-users.php",
  addUser: "/users/add-user.php",
  updateUser: "/users/update-user.php",
  deleteUser: "/users/delete-user.php",
  uploadUsers: "/users/upload-users.php",
  truncateUsers: "/users/truncate.php",
  phases: "/users/get-phases.php",

  fetchAdmins: "/admin/get-admins.php",
  addAdmin: "/admin/add-admin.php",
  updateAdmin: "/admin/update-admin.php",
  deleteAdmin: "/admin/delete-admin.php",
};
